import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { getDocs } from '../preferences/preferenceApi';
import { setSourceDocs } from '../preferences/preferenceSlice';
// REMOVED: AWS SDK - migrated to Firebase Storage
// import AWS from 'aws-sdk';
import useAuth from 'hooks/useAuth';
// MIGRATED: AWS SDK removed, backend now uses Firebase Storage (GCS)

const project = 'document';
export default function Upload({ modalState, setModalState, projectName, fetchFile }) {
    const [docName, setDocName] = useState(projectName);
    const [files, setfiles] = useState([]);
    const [progress, setProgress] = useState();
    const apiHost = process.env.REACT_APP_API_URL;

    // REMOVED: S3 bucket - using Firebase Storage
    // const S3_BUCKET = 'youteach.ai';
    // REMOVED: AWS region
    // const REGION = 'ap-southeast-1';

    const { fetchBillings, billings } = useAuth();

    useEffect(() => {
        setDocName(projectName);
    }, [docName, projectName]);

    useEffect(() => {
        const size_available = parseFloat(billings.total_size) < parseFloat(billings.limit_size);
        const token_available = parseInt(billings.total_token) < parseFloat(billings.limit_token);
        const price_availabel = parseFloat(billings.total_prices) < parseFloat(billings.limit_price);
        // console.log(!size_available || !token_available || !price_availabel)
        if (!size_available || !token_available || !price_availabel) {
            setProgress({ type: 'FAIL', percentage: 0 });
        }
    }, []);

    // REMOVED: AWS configuration
    // AWS.config.update({
    //         accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    //         secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    //         s3Url: 'http://kmou-dp.s3-website-ap-southeast-1.amazonaws.com',
    //         bucketName: S3_BUCKET,
    //         region: REGION
    //     });

    // REMOVED: S3 client - now using Firebase Storage
    // const s3 = new AWS.S3();

    function Progress({ title, isCancellable = false, isFailed = false }) {
        return (
            <div className="mt-5 flex flex-col items-center gap-2">
                <p className="text-xl tracking-[0.15px]">{title}...</p>
                <p className="text-sm text-gray-2000">Quá trình sẽ mất vài phút</p>
                <p className={`ml-5 text-xl text-red-400 ${isFailed ? '' : 'hidden'}`}>
                    Vượt quá giới hạn tokens, vui lòng xem xét tải lên tài liệu nhỏ hơn
                </p>
                <p className="mt-10 text-2xl">{progress?.percentage || 0}%</p>

                <div className="mb-10 w-[50%]">
                    <div className="h-1 w-[100%] bg-purple-30"></div>
                    <div
                        className={`relative bottom-1 h-1 bg-purple-30 transition-all`}
                        style={{ width: `${progress?.percentage || 0}%` }}
                    ></div>
                </div>

                <button
                    onClick={() => {
                        setDocName('');
                        setfiles([]);
                        setProgress(undefined);
                        setModalState('INACTIVE');
                        fetchBillings();
                        fetchFile(project, projectName);
                    }}
                    className={`rounded-3xl bg-purple-30 px-4 py-2 text-sm font-medium text-white ${isCancellable ? '' : 'hidden'}`}
                >
                    Hoàn thành
                </button>
            </div>
        );
    }

    function UploadProgress() {
        return <Progress title="Đang tải lên"></Progress>;
    }

    function TrainingProgress() {
        const dispatch = useDispatch();
        useEffect(() => {
            (progress?.percentage ?? 0) < 100 &&
                setTimeout(() => {
                    fetch(`${apiHost}/api/task_status?task_id=${progress?.taskId}`)
                        .then((data) => data.json())
                        .then((data) => {
                            if (data.status == 'SUCCESS') {
                                if (data.result.limited === true) {
                                    getDocs().then((data) => dispatch(setSourceDocs(data)));
                                    setProgress(
                                        (progress) =>
                                            progress && {
                                                ...progress,
                                                percentage: 100,
                                                failed: true
                                            }
                                    );
                                } else {
                                    getDocs().then((data) => dispatch(setSourceDocs(data)));
                                    setProgress(
                                        (progress) =>
                                            progress && {
                                                ...progress,
                                                percentage: 100,
                                                failed: false
                                            }
                                    );
                                }
                            } else if (data.status == 'PROGRESS') {
                                setProgress(
                                    (progress) =>
                                        progress && {
                                            ...progress,
                                            percentage: data.result.current
                                        }
                                );
                            }
                        });
                }, 5000);
        }, [progress, dispatch]);
        return (
            <Progress
                title="Đang tiến hành huấn luyện Chatbot"
                isCancellable={progress?.percentage === 100}
                isFailed={progress?.failed === true}
            ></Progress>
        );
    }

    const onDrop = useCallback((acceptedFiles) => {
        setfiles(acceptedFiles);
        // setDocName(acceptedFiles[0]?.name);
    }, []);

    const doNothing = () => undefined;

    const uploadFile = async () => {
        const formData = new FormData();
        files.forEach((file) => {
            console.log(file);
            formData.append('file', file);
        });

        formData.append('name', docName);
        formData.append('user', 'local');
        formData.append('user_token', localStorage.getItem('user_token'));
        formData.append('project', project);

        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', (event) => {
            const progress = +((event.loaded / event.total) * 100).toFixed(2);
            setProgress({ type: 'UPLOAD', percentage: progress });
        });
        xhr.onload = () => {
            const { task_id } = JSON.parse(xhr.responseText);
            setProgress({ type: 'TRAINIING', percentage: 0, taskId: task_id });
        };
        xhr.open('POST', `${apiHost + '/api/upload'}`);
        xhr.send(formData);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: true,
        onDragEnter: doNothing,
        onDragOver: doNothing,
        onDragLeave: doNothing,
        maxSize: 25000000,
        accept: {
            'application/pdf': ['.pdf'],
            'text/plain': ['.txt'],
            'text/x-rst': ['.rst'],
            'text/x-markdown': ['.md'],
            'application/zip': ['.zip'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        }
    });

    let view;
    if (progress?.type === 'UPLOAD') {
        view = <UploadProgress></UploadProgress>;
    } else if (progress?.type === 'TRAINIING') {
        view = <TrainingProgress></TrainingProgress>;
    } else if (progress?.type === 'FAIL') {
        view = (
            <>
                <p className="text-xl text-jet">Thêm tài liệu mới</p>
                <p className="mb-3 text-xs text-gray-4000">Đã vượt hạn mức cho phép. Vui lòng kiểm tra hóa đơn</p>
                <button
                    onClick={() => {
                        // setDocName('');
                        // setfiles([]);
                        setModalState('INACTIVE');
                    }}
                    className="font-medium p-2"
                >
                    Quay lại
                </button>
            </>
        );
    } else {
        view = (
            <>
                <p className="text-xl text-jet">Thêm tài liệu mới</p>
                <input
                    type="text"
                    className="h-10 w-[60%] rounded-md border-2 border-gray-5000 px-3 outline-none"
                    disabled
                    value={docName}
                    onChange={(e) => setDocName(e.target.value)}
                ></input>
                <div className="relative bottom-12 left-2 mt-[-18.39px]">
                    <span className="bg-white px-2 text-xs text-gray-4000">Tên trợ lý</span>
                </div>
                <div {...getRootProps()}>
                    <span className="rounded-3xl border border-purple-30 px-4 py-2 font-medium text-purple-30 hover:cursor-pointer">
                        <input type="button" {...getInputProps()} />
                        Chọn tệp tin (có thể chọn nhiều)
                    </span>
                </div>
                <p className="mb-3 text-xs text-gray-4000">
                    Vui lòng upload định dạng .pdf, .txt, .rst, .docx, .md, .zip, xlsx dung lượng dưới 25mb
                </p>
                <div className="mt-9">
                    <p className="mb-5 font-medium text-eerie-black">Các tệp đã upload</p>
                    {files.map((file) => (
                        <p key={file.name} className="text-gray-6000">
                            {file.name}
                        </p>
                    ))}
                    {files.length === 0 && <p className="text-gray-6000">Trống</p>}
                </div>
                <div className="flex flex-row-reverse">
                    <button
                        onClick={uploadFile}
                        className={`ml-6 rounded-3xl bg-purple-30 text-white ${
                            files.length > 0 || docName === '' ? '' : 'bg-opacity-75 text-opacity-80'
                        } px-6 py-2`}
                        disabled={files.length === 0 || docName === ''} // Disable the button if no file is selected
                    >
                        Xử lý
                    </button>
                    <button
                        onClick={() => {
                            setDocName('');
                            setfiles([]);
                            setModalState('INACTIVE');
                        }}
                        className="font-medium"
                    >
                        Quay lại
                    </button>
                </div>
            </>
        );
    }

    return (
        <article className={`${modalState === 'ACTIVE' ? 'visible' : 'hidden'} absolute z-30  h-screen w-screen  bg-gray-alpha`}>
            <article className="mx-auto mt-24 flex w-[90vw] max-w-lg  flex-col gap-4 rounded-lg bg-white p-6 shadow-lg">{view}</article>
        </article>
    );
}
// TODO: sanitize all inputs
